import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';

import {
  SR_API_ACTION_GET_LISTING_BY_ID,
  SR_API_ACTION_FLOOR_PLAN_GET_BY_ID,
  SR_API_ACTION_HOUSEHOLD_LISTING_CHANGE_LISTING,
} from 'api/actionTypes';

import { LISTING_STATUS_LEASED } from 'common/listingConstants';

import { HOUSEHOLD_APPLICATION_STATUS_PAID } from 'common/householdConstants';

import {
  isApplicationPastStatus,
  getHouseholdEarliestApplicationStatus,
} from 'common/householdApplication/applicationHelpers';

import { createFormValidationFn } from 'client/helpers/formikHelpers';

import SrBox from 'client/components/SrBox';
import ButtonDeprecated from 'client/components/ButtonDeprecated';
import SrDarkModal from 'client/components/SrDarkModal';
import SrModalContent from 'client/components/SrModalContent';
import SrFormikField from 'client/components/SrFormikField';

import postWithState from 'client/actions/postWithState';
import withApiState from 'client/helpers/withApiState';

@withApiState({
  changeListingApiState: {
    action: SR_API_ACTION_HOUSEHOLD_LISTING_CHANGE_LISTING,
  },
})
class SrHouseholdListingChangeListingModal extends Component {
  static propTypes = {
    household: PropTypes.object.isRequired,
    householdListing: PropTypes.object.isRequired,
    onUpdateHousehold: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    changeListingApiState: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    this._onSubmitForm = this._onSubmitForm.bind(this);
  }

  async _onSubmitForm(formValues) {
    const listingId = parseInt(formValues.listingId, 10);

    const { household, householdListing, onUpdateHousehold, dispatch, onClose } = this.props;
    const currentListing = householdListing.listing;

    const newListing = await dispatch(postWithState, {
      action: SR_API_ACTION_GET_LISTING_BY_ID,
      payload: {
        listingId: listingId,
      },
    });

    let floorPlan = null;
    if (newListing.floorPlanId) {
      floorPlan = await dispatch(postWithState, {
        action: SR_API_ACTION_FLOOR_PLAN_GET_BY_ID,
        payload: {
          floorPlanId: newListing.floorPlanId,
        },
      });
    }

    if (currentListing.dataSource !== newListing.dataSource) {
      global.alert("We can't change applications from different data sources.");
      return;
    }
    if (household.listingApplications.some(({ listing }) => listing.id === listingId)) {
      global.alert('This household is already applying to this listing.');
      return;
    }
    if (newListing.status === LISTING_STATUS_LEASED) {
      global.alert('The new listing is currently leased.');
      return;
    }
    if (
      floorPlan &&
      floorPlan.tourableApartmentUnits.includes(newListing.apartmentUnit) &&
      isApplicationPastStatus(
        {
          status: getHouseholdEarliestApplicationStatus(householdListing.applications),
        },
        HOUSEHOLD_APPLICATION_STATUS_PAID,
      )
    ) {
      if (
        !global.confirm(
          'This listing is a show unit, are you sure you want the renters to apply to this unit?',
        )
      ) {
        // eslint-disable-line max-len
        return;
      }
    }

    dispatch(postWithState, {
      action: SR_API_ACTION_HOUSEHOLD_LISTING_CHANGE_LISTING,
      payload: {
        householdListingId: householdListing.householdListingId,
        newListingId: listingId,
      },
      onSuccess: () => {
        onUpdateHousehold();
        onClose();
      },
    });
  }

  render() {
    const { onClose, changeListingApiState } = this.props;

    return (
      <SrDarkModal className="SrHouseholdListingChangeListingModal" onClose={onClose}>
        <SrModalContent style={{ width: 690, height: 'auto' }}>
          <Formik
            validate={createFormValidationFn({
              id: 'listingId',
              validations: ['required'],
            })}
            onSubmit={this._onSubmitForm}
            render={(formikBag) => {
              return (
                <Form>
                  <SrFormikField
                    formField={{
                      id: 'listingId',
                      type: 'short_text',
                      properties: {
                        placeholder: 'Listing ID',
                      },
                    }}
                    formikBag={formikBag}
                  />
                  <SrBox marginTop={20}>
                    <ButtonDeprecated
                      type="submit"
                      disabled={!formikBag.isValid || changeListingApiState.inProgress}
                    >
                      change listing
                    </ButtonDeprecated>
                  </SrBox>
                  {changeListingApiState.error && (
                    <div className="errorMessage">{changeListingApiState.error.message}</div>
                  )}
                </Form>
              );
            }}
          />
        </SrModalContent>
      </SrDarkModal>
    );
  }
}

SrHouseholdListingChangeListingModal.displayName = 'SrHouseholdListingChangeListingModal';

export default SrHouseholdListingChangeListingModal;
